const typography = {
  fontFamily: "'Plus Jakarta Sans', sans-serif",

  h1: {
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: 1.25,
  },

  h2: {
    fontWeight: 700,
    fontSize: '1.65rem',
    lineHeight: 1.3,
  },

  h3: {
    fontWeight: 600,
    fontSize: '1.35rem',
    lineHeight: 1.35,
  },

  h4: {
    fontWeight: 600,
    fontSize: '1.2rem',
    lineHeight: 1.4,
  },

  h5: {
    fontWeight: 600,
    fontSize: '1.05rem',
    lineHeight: 1.4,
  },

  h6: {
    fontWeight: 600,
    fontSize: '0.925rem',
    lineHeight: 1.4,
  },

  button: {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
  },

  body1: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },

  body2: {
    fontSize: '0.8125rem',
    letterSpacing: '0rem',
    fontWeight: 400,
    lineHeight: 1.45,
  },

  subtitle1: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.45,
  },

  subtitle2: {
    fontSize: '0.8125rem',
    fontWeight: 500,
    lineHeight: 1.45,
  },

  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.35,
  },
};

export default typography;